import { ReactElement, useState } from 'react'

import { Icon } from 'components/core'
import { Flag } from 'components/Flag'
import { ImageNotFoundIcon } from 'components/Icons'
import { AsinLink } from 'components/Links'
import { CountryCode } from 'types'

import { CogsProductMetadata } from './localTypes'
import * as styles from './styles.scss'

interface ProductCogsProductsProps {
    sku: string
    products: CogsProductMetadata[]
    selectedProductId?: string
}

const ProductCogsProducts = (
    props: ProductCogsProductsProps
): ReactElement | null => {
    const { sku, products = [], selectedProductId } = props
    const [imageOk, setImageOk] = useState<boolean>(true)

    const product = products.find((p) => p.id === selectedProductId)

    return product ? (
        <div className={styles.container}>
            <div className={styles['image-outer']}>
                <div className={styles.image}>
                    {product.small_image_url && imageOk ? (
                        <img
                            src={product.small_image_url}
                            alt={product.title ?? '[product image]'}
                            onError={() => setImageOk(false)}
                        />
                    ) : (
                        <ImageNotFoundIcon
                            className={styles['missing-img-icon']}
                        />
                    )}
                </div>
            </div>
            <div className={styles.text}>
                <div className={styles.title}>{product.title}</div>
                <div className={styles.metadata}>
                    <div className={styles.sku}>
                        <Icon name="TAG" />
                        <span>{sku}</span>
                    </div>
                    <div className={styles.marketplaces}>
                        <Icon name="SHOPPING_BAG" />
                        {products.length > 1 ? (
                            <span className={styles.label}>
                                {products.length} countries
                            </span>
                        ) : null}
                        {products.map((p) => (
                            <Flag
                                key={p.id}
                                country={p.marketplace as CountryCode}
                            />
                        ))}
                    </div>
                    <div className={styles.asin}>
                        <Icon name="AMAZON" />
                        <span className={styles.label}>Related ASIN: </span>
                        <AsinLink
                            asin={product.asin}
                            countryCode={product.marketplace}
                            showAmazonIcon={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    ) : null
}

export default ProductCogsProducts
